import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import _ from 'lodash';
import { useListUserLogEventsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'UserLogEvents',
  props: {
    email: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default: undefined
    },
    columns: {
      type: Array,
      default: function _default() {
        return ['name'];
      }
    },
    filter: {
      type: Function,
      default: function _default() {
        return true;
      }
    }
  },
  emits: ["input", "update:modelValue"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var currentIds = computed(function () {
      return (props.modelValue !== undefined ? props.modelValue : props.value) || [];
    });
    var headers = computed(function () {
      return [{
        value: 'user_id'
      }, {
        value: 'user_agent'
      }, {
        value: 'date'
      }, {
        value: 'ip'
      }, {
        value: 'location'
      }, {
        value: 'actions'
      }].filter(function (o) {
        var _props$columns;
        return (_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.includes(o.value);
      });
    });
    var options = ref({
      page: 1,
      itemsPerPage: 15,
      search: ''
    });
    var variables = computed(function () {
      return {
        email: props.email,
        perPage: options.value.itemsPerPage,
        page: options.value.page - 1
        // search: options.value.search || '',
      };
    });
    var _useListUserLogEvents = useListUserLogEventsQuery(variables),
      result = _useListUserLogEvents.result,
      refetch = _useListUserLogEvents.refetch,
      loading = _useListUserLogEvents.loading;
    var items = computed(function () {
      var _result$value$listUse, _result$value, _result$value$listUse2;
      return (_result$value$listUse = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$listUse2 = _result$value.listUserLogEvents) === null || _result$value$listUse2 === void 0 ? void 0 : _result$value$listUse2.logs) !== null && _result$value$listUse !== void 0 ? _result$value$listUse : [];
    });
    var selected = computed(function () {
      return items.value.filter(function (user) {
        return currentIds.value.filter(Boolean).includes(user.id || '');
      });
    });
    var onInput = function onInput(val) {
      var nextIds = val.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      if (_.isEqual(nextIds, currentIds.value)) {
        return;
      }
      emit('update:modelValue', nextIds);
      emit('input', nextIds);
    };
    var itemCount = computed(function () {
      var _result$value2, _result$value2$listUs;
      return ((_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : (_result$value2$listUs = _result$value2.listUserLogEvents) === null || _result$value2$listUs === void 0 ? void 0 : _result$value2$listUs.total) || 0;
    });
    var getLocation = function getLocation(item) {
      var info = (item === null || item === void 0 ? void 0 : item.location_info) || {};
      var city = info.city_name || '';
      var country = info.country_name || '';
      return [city, country].filter(Boolean).join(' ');
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      currentIds: currentIds,
      headers: headers,
      options: options,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      items: items,
      selected: selected,
      onInput: onInput,
      itemCount: itemCount,
      getLocation: getLocation
    };
  }
});